import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { AngularDatasModule } from '@univacity/angular/datas';
import { AngularUiModule } from '@univacity/angular/ui';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { environment } from '../../../environments/environment';
import { LOCALE } from '@univacity/shared/types';

export interface LocaleNav {
  name: string;
  flag: string;
  link: string;
  locale: LOCALE;
}

@Component({
  selector: 'un-locale-nav',
  imports: [
    CommonModule,
    AngularUiModule,
    NzDropDownModule,
    AngularDatasModule,
  ],
  templateUrl: './locale-nav.component.html',
  styleUrls: ['./locale-nav.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleNavComponent implements OnInit {
  @Input() locales: LocaleNav[] = [
    {
      flag: 'us',
      link: `${environment.appUrl}/${LOCALE.english}/`,
      locale: LOCALE.english,
      name: $localize`English`,
    },
    {
      flag: 'es',
      link: `${environment.appUrl}/${LOCALE.spanish}/`,
      locale: LOCALE.spanish,
      name: $localize`Spanish`,
    },
    {
      flag: 'fr',
      link: `${environment.appUrl}/${LOCALE.french}/`,
      locale: LOCALE.french,
      name: $localize`Frence`,
    },
    {
      flag: 'de',
      link: `${environment.appUrl}/${LOCALE.german}/`,
      locale: LOCALE.german,
      name: $localize`German`,
    },
    {
      flag: 'tr',
      link: `${environment.appUrl}/${LOCALE.turkish}/`,
      locale: LOCALE.turkish,
      name: $localize`Turkish`,
    },
    {
      flag: 'ru',
      link: `${environment.appUrl}/${LOCALE.russian}/`,
      locale: LOCALE.russian,
      name: $localize`Russian`,
    },
  ];

  @Output() localeChange = new EventEmitter<LocaleNav>();
  selectedLocale: LocaleNav = this.locales[0];

  locale = inject(LOCALE_ID);
  ngOnInit(): void {
    this.selectedLocale =
      this.locales.find((l) => l.locale === this.locale) || this.selectedLocale;
  }
  select(locale: LocaleNav) {
    this.selectedLocale = locale;
    this.localeChange.emit(locale);
  }

  get _locales() {
    return this.locales.filter((c) => c.flag !== this.selectedLocale.flag);
  }
}
